import React from "react";
import Mobile_footer from './Mobile_footer';
import Desktop_footer from './Desktop_footer';

const Footer = () => {

  return (
    <div id="footer-container">
      <Mobile_footer />
      <Desktop_footer />
    </div>
  )
}

export default Footer
